export const environment = {
  production: true,
  env: "prod",
  apiHost: "https://production.zceppa.com/",
  pusher: {
    key: "e25692894f683359a2ae",
    cluster: "ap2",
  }
};
